import LegalPageInt, { LegalPageIntProps } from 'ui/customer-support/components/legal-page-int';

type Props = {
  data: LegalPageIntProps;
};

const LegalPageIntTastic = ({ data }: Props) => {
  return <LegalPageInt {...data} />;
};

export default LegalPageIntTastic;
